import { useQuery } from '@tanstack/react-query';
import { getInvoices, type InvoiceListParams } from '../invoices.api';

/**
 * Server-state for the invoices list (TanStack Query — never Zustand, per h12-2 anti-pattern
 * guidance). The query key intentionally excludes any tenant identifier: identity is always
 * derived server-side from the session.
 */
export function useInvoices(params: InvoiceListParams) {
  return useQuery({
    queryKey: ['invoices', 'list', { year: params.year, status: params.status, page: params.page, pageSize: params.pageSize }],
    queryFn: () => getInvoices(params),
    staleTime: 60 * 1000,
  });
}
